var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panda-error-processing"},[_c('h3',{staticStyle:{"margin-bottom":"12px"}},[_vm._v("Opa!")]),_c('span',[_vm._v("Erro de processamento!")])])
}]

export { render, staticRenderFns }